export const invoiceTypes = {
	INVOICE: "invoice",
	CREDIT: "creditInvoice",
};
